import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import { bindSharedWsAgentSync } from './modules/cosmoClaw'

Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})
const store = new Vuex.Store({
  modules,
  getters
})
// 共享 WS 的 agentId 统一跟随 currentAgentId，新增数字人/入口无需各自同步
bindSharedWsAgentSync(store)
export default store
